import { axiosInstance } from "./axios";

export const GetParticipantList = async(search,showDeleted) => {
  return await axiosInstance
    .get(`/participant?search=${search}&showDeleted=${showDeleted}`)
    .then(res =>  res.data.data)
    .catch((err) => console.log("e", err));
};
